import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

export type SaldoContrato = {
    ID: string;
    NUMERO: string;
    DESCRICAO: string;
    VALOR: number | null;
    DATAINICIO: string;
    DATAFIM: string;
    TAXAADM: number;
    TOTAL_FATURADO: number;
    SALDO: number;
};

export const useSaldoContratoController = () => {
    const { userAgencyId } = useAuth();
    const [data, setData] = useState<SaldoContrato[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchSaldo = () => {
        if (!userAgencyId) return;
        setLoading(true);
        api.get(`/contratos-saldo/${userAgencyId}`)
            .then(response => {
                console.log('SaldoContratoController.fetchSaldo response:', response.data);
                setData(response.data);
                setLoading(false);
            })
            .catch(err => {
                console.error('Erro ao buscar saldo de contratos:', err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchSaldo();
    }, [userAgencyId]);

    return { data, loading, fetchSaldo };
};
